import { COLORS } from "./colors";

export enum IncomeTypeEnum {
  PAYMENT = "Оплата від клієнта",
  GRANT = "Грант",
  CREDIT = "Кредит",
  INVESTMENT = "Інвестиції",
  SELLING = "Продаж активів",
  PREPAYMENT = "Передоплата",
  ADVANCE = "Аванс",
  PARTNER_PAYMENT = "Партнерські виплати",
  SUBSIDY = "Субсидія",
  REFUND = "Повернення коштів",
  OTHER = "Інше",
}

export enum ExpenseTypeEnum {
  SALARY = "Зарплата",
  FOOD = "Харчування",
  RENT = "Оренда",
  SERVICES = "Послуги",
  ADVERTISING = "Реклама",
  PROCUREMENT = "Закупівлі",
  MARKETING = "Маркетинг",
  TAXES = "Податки",
  OTHER = "Інше",

}

export const IncomeColors: Record<IncomeTypeEnum, string> = {
  [IncomeTypeEnum.PAYMENT]: COLORS.main1,
  [IncomeTypeEnum.GRANT]: COLORS.blue,
  [IncomeTypeEnum.CREDIT]: COLORS.warning,
  [IncomeTypeEnum.INVESTMENT]: COLORS.main2,
  [IncomeTypeEnum.SELLING]: COLORS.secondary1,
  [IncomeTypeEnum.ADVANCE]: COLORS["bg-text-color"],
  [IncomeTypeEnum.PARTNER_PAYMENT]: "#C7D36F",
  [IncomeTypeEnum.SUBSIDY]: "#99d36fff",
  [IncomeTypeEnum.OTHER]: "#d3886fff",
  [IncomeTypeEnum.REFUND]: "#d36fc7ff",
  [IncomeTypeEnum.PREPAYMENT]: "#746fd3ff"
};

export const ExpenseColors: Record<ExpenseTypeEnum, string> = {
  [ExpenseTypeEnum.SALARY]: COLORS.main2,
  [ExpenseTypeEnum.SERVICES]: COLORS.secondary1,
  [ExpenseTypeEnum.FOOD]: COLORS.main1,
  [ExpenseTypeEnum.RENT]: COLORS.warning,
  [ExpenseTypeEnum.ADVERTISING]: COLORS.blue,
  [ExpenseTypeEnum.OTHER]: "#d3886fff",
  [ExpenseTypeEnum.MARKETING]: "#d36fc7ff",
  [ExpenseTypeEnum.TAXES]: "#99d36fff",
  [ExpenseTypeEnum.PROCUREMENT]: COLORS["bg-text-color"]
};
